module.exports = __webpack_public_path__ + "static/media/translator-screenshot.3df8a87a.png";